
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Message = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M2.8,4.4V20.5H7.1L9.8,23l2.7-2.5h6.4a3.3,3.3,0,0,0,3.3-3.3V4.4ZM20.7,17.2A1.8,1.8,0,0,1,18.9,19h-7L9.8,21,7.7,19H4.3V5.9H20.7Z"></path>
        </g>
      </g>
    </IconBase>);
};

Message.defaultProps = {
  title: 'Message',
};

export default Message;
